import React, { useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";

const Products = (props) => {
  const history = useHistory();
  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
			return false;
    }
  }, []);
  return (
    <div className="dis-flex product-video-container">
      <div className="content-box dis-flex-col">
        <div className="content-box-video">
          <iframe
            src="https://player.vimeo.com/video/875039737?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen"
            style={{ width: "237px", height: "133px" }}
            title="Bulk upload"
          ></iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
        <NavLink to="/add-product1" className="button dis-flex">
          <div className="img">
            <img src="/cart-icon.webp" alt="icon" />
          </div>

          <div className="text">Add Single Product</div>
        </NavLink>
      </div>
      <div className="content-box dis-flex-col">
        <div className="content-box-video">
          <iframe
            src="https://player.vimeo.com/video/849059662?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen"
            style={{ width: "237px", height: "133px" }}
            title="Bulk upload"
          ></iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
        <NavLink to="/bulk-upload" className="button dis-flex">
          <div className="img">
            <img src="/prod-bulk-upload.webp" alt="icon" />
          </div>

          <div className="text">Bulk Upload</div>
        </NavLink>
      </div>
      <div className="content-box dis-flex-col">
        <div className="content-box-video">
          <iframe
            src="https://player.vimeo.com/video/875039409?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen"
            style={{ width: "237px", height: "133px" }}
            title="Bulk upload"
          ></iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
        <NavLink to="/add-Product" className="button dis-flex">
          <div className="img">
            <img src="/document.webp" alt="icon" />
          </div>

          <div className="text">Add From Catalogue</div>
        </NavLink>
      </div>
    </div>
  );
};

export default Products;
